import React from 'react';
import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import { styled } from '@material-ui/core/styles';

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    sx={{
      backgroundColor: '#0088FF',
    }}
    disableFocusListener
    enterTouchDelay={0}
    {...props}
    classes={{ popper: className }}
  />
))`
  & .MuiTooltip-tooltip {
    background-color: #0088ff;
    color: #ffffff;
    font-size: 14px;
    line-height: 22px;
    //font-family: Montserrat;
    padding: 16px;
  }
  & .MuiTooltip-arrow::before {
    background-color: #0088ff;
    border: 1px solid #0088ff;
  }
`;

export default CustomTooltip;